import { Progress } from '@backstage/core-components';
import Avatar from '@material-ui/core/Avatar';
import Box from '@material-ui/core/Box';
import Divider from '@material-ui/core/Divider';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemText from '@material-ui/core/ListItemText';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import Alert from '@material-ui/lab/Alert';
import React from 'react';
import '../../../api/DevToolsApi.esm.js';
import '@backstage/errors';
import '@backstage/core-plugin-api';
import 'react-use/esm/useAsync';
import { useInfo } from '../../../hooks/useInfo.esm.js';
import { InfoDependenciesTable } from './InfoDependenciesTable.esm.js';
import DescriptionIcon from '@material-ui/icons/Description';
import MemoryIcon from '@material-ui/icons/Memory';
import DeveloperBoardIcon from '@material-ui/icons/DeveloperBoard';
import { BackstageLogoIcon } from './BackstageLogoIcon.esm.js';
import FileCopyIcon from '@material-ui/icons/FileCopy';

const useStyles = makeStyles(
  (theme) => createStyles({
    paperStyle: {
      display: "flex",
      marginBottom: theme.spacing(2)
    },
    flexContainer: {
      display: "flex",
      flexDirection: "row",
      padding: 0
    },
    copyButton: {
      float: "left",
      margin: theme.spacing(2)
    }
  })
);
const copyToClipboard = ({ about }) => {
  if (about) {
    let formatted = `OS: ${about.operatingSystem}
Resources: ${about.resourceUtilization}
node: ${about.nodeJsVersion}
backstage: ${about.backstageVersion}
Dependencies:
`;
    const deps = about.dependencies;
    for (const key in deps) {
      if (Object.prototype.hasOwnProperty.call(deps, key)) {
        formatted = `${formatted}    ${deps[key].name}: ${deps[key].versions}
`;
      }
    }
    window.navigator.clipboard.writeText(formatted);
  }
};
const InfoContent = () => {
  const classes = useStyles();
  const { about, loading, error } = useInfo();
  if (loading) {
    return /* @__PURE__ */ React.createElement(Progress, null);
  } else if (error) {
    return /* @__PURE__ */ React.createElement(Alert, { severity: "error" }, error.message);
  }
  return /* @__PURE__ */ React.createElement(Box, null, /* @__PURE__ */ React.createElement(Paper, { className: classes.paperStyle }, /* @__PURE__ */ React.createElement(List, { className: classes.flexContainer }, /* @__PURE__ */ React.createElement(ListItem, null, /* @__PURE__ */ React.createElement(ListItemAvatar, null, /* @__PURE__ */ React.createElement(Avatar, null, /* @__PURE__ */ React.createElement(DeveloperBoardIcon, null))), /* @__PURE__ */ React.createElement(
    ListItemText,
    {
      primary: "Operating System",
      secondary: about?.operatingSystem
    }
  )), /* @__PURE__ */ React.createElement(ListItem, null, /* @__PURE__ */ React.createElement(ListItemAvatar, null, /* @__PURE__ */ React.createElement(Avatar, null, /* @__PURE__ */ React.createElement(MemoryIcon, null))), /* @__PURE__ */ React.createElement(
    ListItemText,
    {
      primary: "Resource utilization",
      secondary: about?.resourceUtilization
    }
  )), /* @__PURE__ */ React.createElement(ListItem, null, /* @__PURE__ */ React.createElement(ListItemAvatar, null, /* @__PURE__ */ React.createElement(Avatar, null, /* @__PURE__ */ React.createElement(DescriptionIcon, null))), /* @__PURE__ */ React.createElement(
    ListItemText,
    {
      primary: "NodeJS Version",
      secondary: about?.nodeJsVersion
    }
  )), /* @__PURE__ */ React.createElement(ListItem, null, /* @__PURE__ */ React.createElement(ListItemAvatar, null, /* @__PURE__ */ React.createElement(Avatar, null, /* @__PURE__ */ React.createElement(BackstageLogoIcon, null))), /* @__PURE__ */ React.createElement(
    ListItemText,
    {
      primary: "Backstage Version",
      secondary: about?.backstageVersion
    }
  ))), /* @__PURE__ */ React.createElement(Divider, { orientation: "vertical", variant: "middle", flexItem: true }), /* @__PURE__ */ React.createElement(
    Button,
    {
      onClick: () => {
        copyToClipboard({ about });
      },
      className: classes.copyButton,
      startIcon: /* @__PURE__ */ React.createElement(FileCopyIcon, null)
    },
    "Copy Info to Clipboard"
  )), /* @__PURE__ */ React.createElement(InfoDependenciesTable, { infoDependencies: about?.dependencies }));
};

export { InfoContent };
//# sourceMappingURL=InfoContent.esm.js.map
